export default __webpack_public_path__ + "static/media/swiggyBolt.fecf85f0.svg";